/**
 * @generated SignedSource<<41b417b4242cecc6f0f7e5d54a3c10de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopFilters_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuFilterPrice_user" | "SbRespRefineMenuFilterDimensions_user" | "SbRespRefineMenuFilterArtSize_user">;
  readonly " $fragmentType": "SbRespRefineTopFilters_user";
};
export type SbRespRefineTopFilters_user$key = {
  readonly " $data"?: SbRespRefineTopFilters_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineTopFilters_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineTopFilters_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterArtSize_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "fd8b3bbacbbba676f4966407d511bcb2";

export default node;
